import { app } from "modular-openscriptjs";
import OffcanvasComponent from "../OffcanvasComponent";

const h = app("h");

export default class MainActionCanvas extends OffcanvasComponent {
	render(...args) {
		return h.$(h.div({ class: "offcanvas-body" }, ...args));
	}
}

